module.exports = __webpack_public_path__ + "static/media/MIAB9959-180731-139_Small.2e4b5a90.jpg";